export enum DirectoryErrors {
    NAME_EXISTS = 'DIRECTORY_NAME_EXISTS',
    ID_NOT_FOUND = 'DIRECTORY_ID_NOT_FOUND',
    ROOT_UPDATE = 'DIRECTORY_ROOT_UPDATE',
    ROOT_DELETION = 'DIRECTORY_ROOT_DELETION',
    MISSING_FILES = 'DIRECTORY_MISSING_FILES',
}

export enum FileErrors {
    NAME_EXISTS = 'FILE_NAME_EXISTS',
    ID_NOT_FOUND = 'FILE_ID_NOT_FOUND',
}
